import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import getEnvFromHost from './helpers/getEnvFromHost/getEnvFromHost';

const appName = 'web-app-login';
const env = getEnvFromHost();
const url =
  'https://faro-collector-prod-eu-west-2.grafana.net/collect/aba369f2ab725471cc428da728e29905';

export const initFaro = () => {
  initializeFaro({
    url,
    app: {
      name: appName,
      environment: env,
    },
    sessionTracking: {
      samplingRate: 0.1,
      persistent: true,
    },
    instrumentations: [
      ...getWebInstrumentations(),

      new ReactIntegration({
        router: createReactRouterV6Options({
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType,
        }),
      }),
    ],
  });
};
